import React, { Component } from 'react';
import { Icon } from '@material-ui/core';
import './TagSelector.scss';

class TagSelector extends Component {
  state = { showTags: false };

  clickListener = (e) => {
    if (document.getElementsByClassName('tags-wrapper').length && !document.getElementsByClassName('tags-wrapper')[0].contains(e.target)) {
      this.setState({ showTags: false });
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.clickListener);
  }

  componentWillUnmount() {
    if (this.clickListener) document.removeEventListener('click', this.clickListener);
  }

  renderTagsInDropdown() {
    const { tags, selectedTags, onSelectedTag } = this.props;
    if (!tags || !selectedTags) return null;
    return tags.map(tag => {
      const selected = selectedTags.map(tag => tag._id).indexOf(tag._id) > -1;

      return (
        <div key={tag._id} className="tag-wrapper" onClick={() => onSelectedTag(tag)}>
          {/* <div className="tag-circle" style={{ backgroundColor: (selected ? '#faa85f' : '#FFF'),
            border: `1px solid #${selected ? 'faa85f' : '575757'}` }}></div> */}
          <div className="tag-circle" style={{ backgroundColor: (selected ? '#faa85f' : '#FFF'),
            border: `1px solid #${selected ? 'faa85f' : '575757'}` }} />
          <div className="tag-name">{tag.name}</div>
        </div>
      );
    });
  }

  renderSelectedTags() {
    if (!this.props.selectedTags) return null;
    return this.props.selectedTags.map(tag =>
      <div key={tag._id} className="selected-tag">{tag.name}</div>
    );
  }

  render() {
    const { showTags } = this.state;

    return (
      <div className="tags-wrapper" id="tags-wrapper">
        <div className="add-tags-button">
          <div style={{ width: '100%', display: 'flex' }} onClick={() => this.setState({ showTags: !showTags })}>
            <Icon className="add-tags-button-icon">add_circle</Icon>
            <div className="add-tags-button-text">ADD TAG</div>
          </div>
          <div className="tags-dropdown" style={{ display: (showTags ? 'inline-block' : 'none') }}>
            {this.renderTagsInDropdown()}
            <div className="tag-done" onClick={() => this.setState({ showTags: false })}>DONE</div>
          </div>
        </div>
        {this.renderSelectedTags()}
      </div>
    );
  }
}

export { TagSelector };


// WEBPACK FOOTER //
// ./src/components/TagSelector.js